import type { ReactNode } from "react";

export type AppShellNavItem = {
  href: string;
  label: string;
  current?: boolean;
};

export type AppShellProps = {
  brand: string;
  eyebrow?: string;
  environment?: string;
  navigation?: readonly AppShellNavItem[];
  children: ReactNode;
  footer?: ReactNode;
};

export const AppShell = ({
  brand,
  eyebrow,
  environment,
  navigation = [],
  children,
  footer,
}: AppShellProps) => (
  <div className="app-shell">
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
    <header className="site-header">
      <div className="site-header__identity">
        {eyebrow ? <p className="site-header__eyebrow">{eyebrow}</p> : null}
        <a className="site-header__brand" href="/" aria-label={`${brand} home`}>
          {brand}
        </a>
      </div>
      <div className="site-header__utility">
        {environment ? <span className="environment-badge">{environment}</span> : null}
        {navigation.length > 0 ? (
          <nav aria-label="Primary navigation">
            <ul className="site-nav">
              {navigation.map((item) => (
                <li key={item.href}>
                  <a href={item.href} aria-current={item.current ? "page" : undefined}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
      </div>
    </header>
    <main id="main-content">{children}</main>
    <footer className="site-footer">
      {footer ?? <p>Representative portfolio demo. No production data.</p>}
    </footer>
  </div>
);
